// FinalSummaryCommissionSettlement.js
import React from "react";
import SummaryCardLayout from "./SummaryCardLayout";
import { getFullName } from "../../../../Modules/utils/fullname";
import SettlementImpact from "./SettlementImpact";

export default function FinalSummaryCommissionSettlement(props) {
  const { data } = props;

  const total = Number(data.totalAmount || 0);

  const INR = (n) => "₹" + Number(n || 0).toLocaleString("en-IN");

  const renderPrintableContent = (d) => (
    <div className="p-0">
      <h6 className="fw-bold mb-2">Commission Settlement Summary</h6>

      <table className="table table-borderless table-sm mb-3">
        <tbody>
          <tr>
            <td>FE</td>
            <td className="text-end fw-bold">
              {getFullName(d.relatedUser || d.agent)}
            </td>
          </tr>

          <tr>
            <td className="">Commission Applied</td>
            <td className="text-end fw-bold">{INR(total)}</td>
          </tr>
        </tbody>
      </table>

      <h6 className="fw-bold mt-3">Balances After Settlement</h6>
      <table className="table table-sm mb-2">
        <tbody>
          <tr>
            <td>User Balance Due</td>
            <td className="text-end fw-bold">
              {INR(Number(d.userBalanceDue?.total ?? 0))}
            </td>
          </tr>
          <tr>
            <td>Commission Balance</td>
            <td className="text-end fw-bold">
              {INR(Number(d.commissionBalance?.total ?? 0))}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );

  return (
    <div>
      {/* Summary card */}
      <SummaryCardLayout
        mode={"details"}
        data={data}
        renderPrintableContent={() => (
          <SettlementImpact
            data={data}
            opt={{ transactionsMode: "totalOnly" }}
          />
        )}
        renderSummaryContent={() => <SettlementImpact data={data} />}
        onBack={() => props.onSubmit({ step: data.step - 1 })}
        onSubmit={props.onFinalSubmit}
        onClose={props.handleClose}
        onEdit={props.handleEdit}
        onDelete={props.handleDelete}
        onApprove={props.handleApprove}
      />

      {/* New: Settlement impact trigger - button opens modal from SettlementImpact component */}
    </div>
  );
}
